module.exports = __webpack_public_path__ + "img/captchaModalUA.4af32f2a.png";